export default __webpack_public_path__ + "static/media/profile.4aa827c3.jpg";